/**
 * 全渠道客服 / WebSocket 通道与事件动作常量字典
 * 统一管理全系统核心业务事件动作，杜绝硬编码魔法字符串
 */
export const CHAT_WS_CHANNELS = {
  OMNI_CHAT: 'omni_chat',
} as const;

export const CHAT_WS_ACTIONS = {
  // 新消息通知
  NEW_MESSAGE: 'omni_new_message',

  // 消息已读通知
  MESSAGE_READ: 'omni_message_read',

  // 消息内容/状态更新（如 OCR 图片异步识别补全）
  MESSAGE_UPDATED: 'omni_message_updated',

  // 未读数变更
  UNREAD_UPDATED: 'omni_unread_updated',

  // 会话属性/画像/订单变更
  CONVERSATION_UPDATED: 'omni_conversation_updated',

  // 账号/店铺状态变更
  ACCOUNT_STATE: 'omni_account_state',

  // 账号失效/需重新登录通知
  RELOGIN_REQUIRED: 'omni_relogin_required',

  // 自动建单成功通知
  AUTO_ORDER_CREATED: 'omni_auto_order_created',

  // 自动建单未完成/失败通知
  AUTO_ORDER_FAILED: 'omni_auto_order_failed',

  // 历史会话同步完成
  SYNC_COMPLETED: 'omni_sync_completed',
} as const;

export type ChatWsAction = (typeof CHAT_WS_ACTIONS)[keyof typeof CHAT_WS_ACTIONS];
export type ChatWsChannel = (typeof CHAT_WS_CHANNELS)[keyof typeof CHAT_WS_CHANNELS];

/**
 * 判断是否为新消息事件动作
 */
export const isNewMessageAction = (action?: string | null): boolean => {
  return action === CHAT_WS_ACTIONS.NEW_MESSAGE;
};

/**
 * 判断是否为会话属性更新事件动作
 */
export const isConversationUpdatedAction = (action?: string | null): boolean => {
  return action === CHAT_WS_ACTIONS.CONVERSATION_UPDATED;
};

/**
 * 判断是否为未读数更新事件动作
 */
export const isUnreadUpdatedAction = (action?: string | null): boolean => {
  return action === CHAT_WS_ACTIONS.UNREAD_UPDATED;
};

/**
 * 判断是否为消息已读事件动作
 */
export const isMessageReadAction = (action?: string | null): boolean => {
  return action === CHAT_WS_ACTIONS.MESSAGE_READ;
};

/**
 * 判断是否为消息内容/状态更新事件动作
 */
export const isMessageUpdatedAction = (action?: string | null): boolean => {
  return action === CHAT_WS_ACTIONS.MESSAGE_UPDATED;
};

export default CHAT_WS_ACTIONS;
